<template>
	<v-layout>
		<v-flex :xs6="lead_time" v-if="document.messages || (document.notes && document.include_notes)">
			<div class="preview-proposal__messages" v-if="document.messages">
				<h4 class="body-1 font-weight-bold">Messages:</h4>
				<p>{{document.messages}}</p>
			</div>
			<div class="preview-proposal__notes" v-if="document.notes && document.include_notes">
				<h4 class="body-1 font-weight-bold">Notes:</h4>
				<p>{{document.notes}}</p>
			</div>
		</v-flex>

		<v-flex :xs6="document.messages || (document.notes && document.include_notes)" v-if="lead_time">
			<div class="preview-proposal__lead-time">
				<h4 class="body-1 font-weight-bold">Lead Time:</h4>
				<p>{{computed_lead_time}}</p>
				<p v-if="has_custom_lead_time">*May need additional lead time, provided by manufacturer.</p>
			</div>
		</v-flex>
	</v-layout>
</template>

<script>
var { quoteBuilder } = require("@root/mixins");
import { mapGetters } from "vuex";

export default {
	mixins: [quoteBuilder],

	data() {
		return {};
	},

	computed: {
		...mapGetters("documents", {
			LEAD_TIME: "leadTime",
			LEAD_TIME_MEASURE: "leadTimeMeasure"
		}),

		lead_time() {
			return this.LEAD_TIME(this.document.id);
		},

		lead_time_measure() {
			return this.LEAD_TIME_MEASURE(this.document.id);
		},

		has_custom_lead_time() {
			return (
				_.find(this.document.line_items, item => {
					return this.getObjectValue("part.lead_time", item) === null;
				}) !== undefined
			);
		},

		computed_lead_time() {
			if (this.lead_time > 30 && this.lead_time_measure === "days") {
				return `${Math.ceil(this.lead_time / 7)} weeks`;
			} else {
				return `${this.lead_time} ${this.lead_time_measure}`;
			}
		}
	}
};
</script>
